import { render } from "./DownloadModal.vue?vue&type=template&id=7f2fd84c&scoped=true"
import script from "./DownloadModal.vue?vue&type=script&lang=js"
export * from "./DownloadModal.vue?vue&type=script&lang=js"

import "./DownloadModal.vue?vue&type=style&index=0&id=7f2fd84c&scoped=true&lang=css"

import exportComponent from "../../../../../../labcheckup/labhub_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2fd84c"]])

export default __exports__